import clsx from 'clsx';

import {Spinner} from '../Spinner/Spinner';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isPending?: boolean;
  children?: React.ReactNode;
};
export function SleeveButtons({
  className,
  isPending,
  children,
  ...props
}: Props) {
  return (
    <div
      className={clsx(
        'flex shrink-0 flex-col gap-2 px-4 py-4 sm:flex-row-reverse sm:flex-wrap',
        className
      )}
      {...props}
    >
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      {isPending ? <Spinner size="sm" /> : <>{children}</>}
    </div>
  );
}

SleeveButtons.displayName = 'SleeveButtons';
